export default {
  // General
  save: "저장",
  saving: "저장 중",
  cancel: "취소",
  edit: "편집",
  delete: "삭제",
  profile: "프로필",
  settings: "설정",
  logout: "로그아웃",
  language: "언어",
  loading: "로딩 중",
  submit: "제출",
  search: "검색...",
  back: "뒤로",
  next: "다음",
  previous: "이전",
  continue: "계속",
  done: "완료",
  error: "오류",
  success: "성공",
  warning: "경고",
  info: "정보",
  close: "닫기",
  open: "열기",
  yes: "예",
  no: "아니오",
  ok: "확인",
   
  // Authentication
  auth: {
    signIn: "로그인",
    signUp: "회원가입",
    signOut: "로그아웃",
    forgotPassword: "비밀번호를 잊으셨나요?",
    resetPassword: "비밀번호 재설정",
    sendResetLink: "재설정 링크 보내기",
    createAccount: "계정 만들기",
    alreadyHaveAccount: "이미 계정이 있으신가요?",
    dontHaveAccount: "계정이 없으신가요?",
    or: "또는",
    continueWith: "계속하기",
    google: "구글",
    facebook: "페이스북",
    apple: "애플",
    twitter: "트위터",
    passwordRequirements: "비밀번호는 8자 이상이어야 합니다",
    passwordMatch: "비밀번호가 일치해야 합니다",
    emailInvalid: "유효한 이메일 주소를 입력해주세요"
  },
  
  // Profile specific
  username: "사용자 이름",
  email: "이메일",
  password: "비밀번호",
  confirmPassword: "비밀번호 확인",
  joinDate: "가입일",
  streak: "연속 기록",
  xp: "XP",
  plan: "플랜",
  free: "무료",
  pro: "프로",
  premium: "프리미엄",
  referralCode: "추천 코드",
  share: "공유",
  copy: "복사",
  copied: "복사됨!",
  contactUs: "문의하기",
  termsOfService: "서비스 약관",
  privacyPolicy: "개인정보 처리방침",
  accountSettings: "계정 설정",
  changePassword: "비밀번호 변경",
  deleteAccount: "계정 삭제",
  deleteAccountConfirm: "정말로 계정을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
  updateProfile: "프로필 업데이트",
  profileUpdated: "프로필이 성공적으로 업데이트되었습니다",
  memberSince: "가입일",
  noSetsYet: "아직 세트가 없습니다 :(",
  upgradeToPro: "프로로 업그레이드",
  recentActivity: "최근 활동",
  shareWithAFriend: "친구와 공유",
  contactTheTeam: "팀에 문의하기",
  termsAndConditions: "이용약관",
  editUsername: "사용자 이름 편집:",
  logOut: "로그아웃",
  usernameError1: "사용자 이름은 비워둘 수 없습니다",
  usernameError2: "다른 사용자 이름을 입력해주세요",
  usernameError3: "사용자 이름에 공백을 포함할 수 없습니다",
  usernameError4: "사용자 이름에 대문자를 포함할 수 없습니다",
  usernameError5: "사용자 이름에 특수 문자를 포함할 수 없습니다",
  usernameError6: "사용자 이름은 4~18자 사이여야 합니다",
  usernameError7: "사용자 이름에 부적절한 내용이 포함되어 있습니다",
  usernameError8: "이 사용자 이름은 이미 사용 중입니다",
  clickOrDragAndDrop: "클릭하거나 드래그 & 드롭하여 업로드",
  confirm: "확인",
  retake: "다시 찍기",

  // BottomNav
  profile: "프로필",
  home: "홈",
  library: "내 라이브러리",
  saved: "저장됨",
  rankings: "랭킹",

  // Feature
  backToLibrary: "라이브러리로 돌아가기",
  exploreSets: "세트 탐색",
  communitySets: "커뮤니티 세트",
  mySets: "내 세트",
  alreadyAdded: "이미 추가됨",
  addToLibrary: "라이브러리에 추가",
  loading: "로딩 중...",
  loadMoreSets: "더 많은 세트 불러오기",
  by: "작성자",
  makePublic: "공개하기",
  subscriptionRequired: "구독 필요",
  subscriptionRequiredMessage: "라이브러리에는 한 번에 10개의 세트만 추가할 수 있습니다. 프리미엄으로 업그레이드하여 제한 없는 세트를 사용하세요!",

  // My Library
  deleteSet: "세트 삭제",
  deleteSetConfirmation: "이 세트를 삭제하시겠습니까?",
  yesDelete: "예, 삭제",
  collections: "공개 세트",
  myLibrary: "내 라이브러리",
  outOf10Sets: "10개 세트 중 추가됨",
  switchBackToPro: "프로로 전환",
  upgradeToPro: "프로로 업그레이드",
  outOf10OnFree: "10개 세트 중 무료로 추가됨.",
  letMeCook: "나에게 요리 좀 해줘",
  selectMode: "모드 선택",
  multipleChoice: "多项选择",
  flashcards: "플래시카드",
  freeResponse: "자유응답",
  proOnly: "프로 전용",
  leaderboard: "리더보드",
  favorites: "즐겨찾기",
  profile: "프로필",
  reportBugs: "버그 신고",

  // Question Card
  correctMessage: "정답! 잘 했어요.",
  typeYourAnswer: "답변을 입력하세요...",
  submitAnswer: "답변 제출",
  responseCannotBeBlank: "답변을 입력하세요",
  noAnswerAvailable: "답변이 없습니다",
  answerGuideline: "답변 가이드라인:",
  pleaseSubmitAnswerFirst: "답변을 먼저 제출해주세요",
  revealAnswer: "정답 공개",
  hideAnswer: "정답 숨기기",
  gradingInProgress: "채점 진행 중...",
  grading: "채점",
  answerGuidelines: "답변 가이드라인",
  finalScore: "최종 점수:",
  evaluateAnswer: "답변 평가",

  // Saved
  favorites: "즐겨찾기",
  searchQuestions: "질문 검색...",
  noSavedQuestions: "아직 저장된 질문이 없습니다.",

  // Scroller
  loadingMoreQuestions: "더 많은 질문 불러오는 중",

  // New Prompt
  deleteSet: "세트 삭제",
  deleteSetConfirmation: "이 세트를 삭제하시겠습니까?",
  yesDelete: "예, 삭제",
  cancel: "취소",
  setLimitReached: "세트 제한 도달",
  setLimitError: "라이브러리에 동시에 10개의 세트만 가질 수 있습니다. 프리미엄으로 업그레이드하여 제한 없는 세트를 사용하세요!",
  close: "닫기",
  uploadNotes: "노트 업로드",
  general: "일반",
  title: "제목",
  setTitleMessage: "AI가 생성한 Cookr 질문에 제목을 지정하여 나중에 쉽게 액세스할 수 있도록 합니다.",
  titleError1: "제목을 입력하세요",
  titleError2: "제목에 부적절한 내용이 포함되어 있습니다",
  content: "내용",
  setContentMessage: "노트, 강의 또는 기타 텍스트 콘텐츠를 복사하여 붙여넣으세요.",
  contentError1: "내용을 입력하세요",
  contentError2: "내용에 부적절한 내용이 포함되어 있습니다",
  subject: "주제",
  setSubjectMessage: "이 콘텐츠의 주제 또는 주제는 무엇입니까?",
  subjectError1: "주제를 입력하세요",
  subjectError2: "주제에 부적절한 내용이 포함되어 있습니다",

  // Payment Confirmation
  returnToProfile: "프로필로 돌아가기",

  // Plans
  confirmSwitch: "무료 플랜 전환 확인",
  confirmSwitchMessage: "정말로 무료 플랜으로 전환하시겠습니까? 프리미엄 기능에 대한 액세스가 제한됩니다.",
  buttonConfirm: "전환 확인",
  processing: "처리 중...",
  unlimitedScrolling: "무제한 스크롤",
  unlimitedSubjects: "무제한 주제",
  aiTutorBot: "AI 튜터봇",
  newFeatureAccess: "새 기능 액세스",
  saveScrolls: "스크롤 저장",
  infiniteNoteUploads: "무제한 노트 업로드",
  answerExplanations: "답변 설명",
  shareScrolls: "스크롤 공유",
  everythingInStandard: "스탠다드에 모든 것",
  current: "현재",
  switchOver: "전환",
  forever: "/영원히",
  monthly: "/월간",
  yearly: "/연간",

  // Leaderboard
  leaderboard: "리더보드",

  // Home.js
  pickASubject: "세션을 시작하려면 주제를 선택하세요!",

  // scrollerLoader
  generatingContent: "콘텐츠 생성 중...",

  // Dropdown
  choose: "선택",
  titleTooLong: "제목은 100자를 초과할 수 없습니다",
}

